import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import FleurKintsugi from "../brand/FleurKintsugi";
import KintsugiScrollVein from "../brand/KintsugiScrollVein";
import Reveal from "./Reveal";

export default function StoryTeaser({ eyebrow, title, text, quote, portrait, name }) {
  return (
    <section className="relative overflow-hidden py-20 lg:py-28" data-testid="story-teaser-section">
      <KintsugiScrollVein variant="corner-tl" strokes={2} opacity={0.45} />
      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-[0.8fr_1.2fr] gap-12 lg:gap-20 items-center">
        <Reveal className="relative order-2 lg:order-1">
          <div className="kintsugi-frame aspect-[4/5] w-full max-w-xs mx-auto lg:max-w-sm" style={{ transform: "rotate(-2.5deg)" }} data-testid="story-teaser-portrait">
            <img src={portrait} alt={name} loading="lazy" />
          </div>
          <div className="absolute -bottom-10 right-2 lg:right-0 flex items-center gap-3" aria-hidden="true">
            <FleurKintsugi size={30} />
            <span className="font-vibes text-2xl gold-text">{name}</span>
          </div>
        </Reveal>

        <Reveal delay={150} className="order-1 lg:order-2">
          <div className="smallcaps-label mb-4" data-testid="story-teaser-eyebrow">{eyebrow}</div>
          <h2 className="font-display text-4xl lg:text-5xl leading-tight mb-6" data-testid="story-teaser-title">{title}</h2>
          <blockquote className="font-vibes molten-flow leading-[1.15] mb-6" style={{ fontSize: "clamp(1.6rem, 2.6vw, 2.2rem)" }}>
            « {quote} »
          </blockquote>
          <p className="text-muted-foreground leading-relaxed max-w-xl mb-10" data-testid="story-teaser-text">{text}</p>
          <Link to="/mon-histoire" className="btn-gold-marble inline-flex items-center gap-3 rounded-full" data-testid="story-teaser-cta">
            Lire mon histoire <ArrowRight className="w-4 h-4" />
          </Link>
        </Reveal>
      </div>
    </section>
  );
}
